﻿import $ from "jquery";
import { GuiBase } from "./GuiBase";
import { IModalConfirm } from "./Interface/IModalConfirm"

export class GuiDetailGeneric extends GuiBase {

    // Prellschutz: verhindert Mehrfach-Absenden des Löschen-Requests (DEVCLR-286)
    private deleteInProgress = false;

    constructor(source: string) {
        super(source);
    }

    protected override attachEvents() {
        this.log("attacheEvents");
        super.attachEvents();

        // Button Bar
        $("#btnDetailNavSave").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickBarSave(e); });
        $("#btnBarDelete").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickBarDelete(e); });
        $("#mdlDeletebtnDelete").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickConfirmDelete(e); });
        $("#btnBarCopy").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickBarCopy(e); });
        $("#btnUnlock").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickLock(e, true); });
        $("#btnLock").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickLock(e, false); });
        $("a.addtab").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickAddTab(e); });

        // Action Buttons BGS
        $("#btnBarSign").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.doAction(e); });
        $("#btnBarSend").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.doAction(e); });
        $("#btnBarDisconnect").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.doAction(e); });

         
        // Element in Liste, kein Button 
        $("div.erz-list-element > div").not(".col-button").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickDetailRow(e); });

        // Element in Liste mit Button
        $("div.erz-list-element button.btn-erz-list-element-add").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickDetailAdd(e); });

        $(document).on("keydown", (e) => {
            this.log(`keydown=${e.which}`);
            if (e.which === 13) {
                const ctrl = $(e.target);
                const inputType = ctrl.prop('type') as string;
                if (inputType === "text" || inputType === "select-one") {
                    e.preventDefault();
                    //$("#btnDetailNavSave").trigger("click");
                }
            }
            if (e.which === 27) {
                const ctrl = $(e.target);
                const inputType = ctrl.prop('type') as string;
                if (inputType === "text" || inputType === "select-one" || inputType === "textarea") {
                    e.preventDefault();
                    const url = $("a#btnBarBack").attr("href") as string;
                    this.gotoUrl(url);
                }
            }
        });

        $(document).ready(() => {
            $("form#detailForm input[type!=hidden]:first").focus();
        });
    }

    protected validateClient() {
        return true;
    }

    //#region  ### Ereignisse in Bar ###

    protected beforeSave() { }

    protected clickBarSave(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickBarSave");

        this.beforeSave();

        if (!this.form.checkValidity()) {
            this.log("invalid form");
            e.stopPropagation(); // Postback anhalten

           this.form.reportValidity();
            // ggf. Tabwechsel
            const f = $(this.form).find(".form-control:invalid,.form-select:invalid,.form-check-input:invalid");

            const tabError = f.closest(".tab-pane");
            if (tabError.length > 0) {
                this.changeToTab(`#${tabError[0].id}`);
            }

            f.focus();
            this.createToastValidate("Validierung", "Daten nicht valide", "error", 5000);
            return;
        }
        // zweite Stufe der Validierung. Fachliche Zusammenhänge
        if (!this.validateClient()) {
            this.log("invalid form, client validation");
            e.preventDefault();
            return;
        }

        this.createSpinner($("#btnDetailNavSave"));
        this.lock();

        // save current Tab
        const tab = $("ul.nav.nav-tabs li.nav-item button.active").data("bs-target") as string;
        $("input#CurrentTab").val(tab);

        // Submit form über Browser Button

    }

    protected clickBarDelete(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickBarDelete");
        e.preventDefault();
        const btn = $(e.currentTarget);
        const href = btn.data("url") as string;

        const json = $("#mdlDeleteConfig").text();
        const modalConfirm = JSON.parse(json) as IModalConfirm;
        if (modalConfirm != undefined) {
            $("#mdlDelete .modal-title").html(modalConfirm.ModalTitle);
            $("#mdlDelete .modal-body").html(modalConfirm.ModalBody);
            $("#mdlDelete #mdlDeletebtnDelete").html(modalConfirm.ModalBtnOkText);
        }
        $("#mdlDeletebtnDelete").attr("href", href);
        // Prellschutz zurücksetzen, falls der Dialog vorher schon einmal geöffnet/gesperrt wurde
        this.deleteInProgress = false;
        $("#mdlDeletebtnDelete").removeClass("disabled").removeAttr("aria-disabled").find(".spinner-grow").remove();
        $("#mdlDelete").modal("show");
    }

    // Bestätigen im Löschen-Dialog: nur der erste Klick darf navigieren. Weitere Klicks werden
    // geblockt (Prellschutz), damit kein zweiter Delete-Request auf eine bereits gelöschte Aktion
    // trifft (sonst serverseitig "Sequence contains no elements"). Zusätzlich Progress-Spinner.
    protected clickConfirmDelete(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickConfirmDelete");
        const btn = $(e.currentTarget);

        if (this.deleteInProgress) {
            e.preventDefault();
            return;
        }
        this.deleteInProgress = true;

        // Button sperren (.disabled -> pointer-events:none) + Progress-Spinner. Die href-Navigation
        // läuft weiter, der Delete wird also genau einmal ausgeführt.
        btn.addClass("disabled").attr("aria-disabled", "true");
        this.createSpinner(btn);
    }

    protected clickBarCopy(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickBarCopy");
        e.preventDefault();
        const btn = $(e.currentTarget);
        const href = btn.data("url") as string;

        const json = $("#mdlCopyConfig").text();
        const modalConfirm = JSON.parse(json) as IModalConfirm;
        if (modalConfirm != undefined) {
            $("#mdlCopy .modal-title").html(modalConfirm.ModalTitle);
            $("#mdlCopy .modal-body").html(modalConfirm.ModalBody);
            $("#mdlCopy #mdlCopybtnCopy").html(modalConfirm.ModalBtnOkText);
        }
        $("#mdlCopybtnCopy").attr("href", href);
        $("#mdlCopy").modal("show");


    }



    protected clickLock(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>, state: boolean) {
        this.log("clickLock");

        if (!this.form.checkValidity()) {
            this.log("invalid form");
            e.stopPropagation();
        } else {
            $("#VmDetail_Aktiv").val(state ? "True" : "False");
            this.lock();
            // Submit form über Browser Button
        }
    }


    protected clickAddTab(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickAddTab");
        let tab = $("#headtab button.active").data("bs-target") as string;
        const href = $(e.currentTarget).attr("href");
        tab = encodeURIComponent(tab);
        const newHref = `${href}?tab=${tab}`;
        $(e.currentTarget).attr("href", newHref);
    }

    //#endregion

    //#region  ### Ereignisse in Liste ###

    protected getUrlParameter(): string {
        return "";
    }

    protected clickDetailRow(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickDetailRow");
        e.preventDefault();

        const ele = $(e.currentTarget);
        const head = ele.closest("div.erz-detail-list");

        let url = head.data("url-detail") as string; // goto url im Kopf
        let parameter = head.data("url-detail-parameter") as string | undefined; // goto url im Kopf
        const divRow = ele.closest(".erz-list-element");
        if (divRow.hasClass("noedit")) return;
        const id = divRow.data("id") as string | number | undefined; // id in row

        if (id == undefined) return;
        if (parameter == undefined) parameter = "id";
        url = url + "?" + parameter + "=" + id;

        //// url-detail-hidden
        //var idHidden = head.data("url-detail-hidden");
        //if (idHidden != undefined) {
        //    var value= $("#" + idHidden).val();
        //    url = url + "&" + idHidden + "=" + value;
        //}

        const extraParameter = this.getUrlParameter();
        if (extraParameter != undefined && extraParameter.length > 0) {
            url = url + "&" + extraParameter;
        }

        this.gotoUrl(url);
    }
    /**
     * Create/Add Button in Liste geklickt. Url dem Button entnehmen
     */
    protected clickDetailAdd(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickDetailAdd");
        e.preventDefault();

        const url = $(e.currentTarget).data("url") as string;
        this.gotoUrl(url);
    }

    //#endregion
     

    clickActionButton(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log(e.currentTarget.id);
        this.doAction(e);
    } 

    clickActionButtonConfirm(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log(`clickActionButtonConfirm: ${e.currentTarget.id}`);
        e.preventDefault();
        
        const guiAktion = $(e.currentTarget).data("guiaktion") as string;

        $("#mdlConfirm #btnConfirmMdlConfirm").data("guiaktion", guiAktion);
        // off(): sonst hängt jedes Öffnen des Dialogs einen weiteren Handler an (Mehrfach-Submit)
        $("#mdlConfirm #btnConfirmMdlConfirm").off("click").on("click", (evt: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => {
            $("#mdlConfirm").modal("hide");
            this.doAction(evt);
            $("#detailForm").submit();
        });
        $("#mdlConfirm").modal("show");
    }

}
